import React from 'react';
import { ExternalEventLink } from '../../components/form-elements/Link';

function TireEnergyLabelLinks({ tire }) {
    if (!tire.energyLabelUrl) return null;

    return (
        <>
            <div>
                <ExternalEventLink
                    to={tire.energyLabelUrl}
                    action="Klick-Reifen-Label"
                    label={tire.selectedBezugsquelle?.artNummer || tire.bezeichnung}
                    fullWidth
                    modifier="danger"
                >
                    EU-Reifenlabel
                </ExternalEventLink>
            </div>
            {tire.dataSheetUrl && (
                <div>
                    <ExternalEventLink
                        to={tire.dataSheetUrl}
                        action="Klick-Reifen-Datenblatt"
                        label={tire.selectedBezugsquelle?.artNummer || tire.bezeichnung}
                        fullWidth
                        modifier="danger"
                    >
                        Datenblatt
                    </ExternalEventLink>
                </div>
            )}
        </>
    );
}

export default TireEnergyLabelLinks;
